import React, { useEffect } from "react";

import Props from "./props";
import { useAppTitle } from "../../../state/hooks/MainHooks/useAppTitle";

const New: React.FC<Props> = props => {
    const { setAppTitle } = useAppTitle();
    useEffect(() => {
        setAppTitle(props.title);
        return () => {
            setAppTitle("");
        };
    }, [setAppTitle, props.title]);
    return <div>New [User]</div>;
};

export default New;
